import { Component, OnInit } from '@angular/core';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { DecideComponent } from '../../../../features/decide/decide.component';
import { PrepareComponent } from '../../../../features/prepare/prepare.component';
import { DecideService } from '../../../../features/decide/services/decide.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    ToolbarComponent,
    FooterComponent,
    MatProgressSpinnerModule,
    MatTabsModule,
    DecideComponent,
    PrepareComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  constructor(private service: DecideService) {}

  async ngOnInit() {
    try {
      const result = await this.service.getDecisions();
      this.service.decisionsSubject.next(result);
    } catch (error) {
      console.error(error);
    }
  }
}
